import { render, staticRenderFns } from "./CardFacility.vue?vue&type=template&id=8b1679c4&scoped=true"
import script from "./CardFacility.vue?vue&type=script&lang=js"
export * from "./CardFacility.vue?vue&type=script&lang=js"
import style0 from "./CardFacility.vue?vue&type=style&index=0&id=8b1679c4&prod&lang=scss"
import style1 from "./CardFacility.vue?vue&type=style&index=1&id=8b1679c4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b1679c4",
  null
  
)

export default component.exports